import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/motion";
import { IMAGES } from "@/data/site";

export default function PhotoBreak() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} className="relative h-[72vh] overflow-hidden bg-navy" data-testid="photo-break-section">
      <motion.img
        src={IMAGES.steel}
        alt="Large-scale structural steel construction"
        style={{ y }}
        className="absolute inset-0 h-[124%] w-full object-cover"
      />
      <div className="absolute inset-0 bg-navy/70" />
      <div className="relative z-10 mx-auto flex h-full max-w-7xl flex-col justify-center px-6">
        <Reveal y={16} className="flex items-center gap-4">
          <span className="h-px w-12 bg-gold" />
          <span className="text-xs font-semibold uppercase tracking-[0.35em] text-gold">The Formcore Difference</span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-8 max-w-3xl font-heading text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-6xl">
            Experience That Understands <span className="text-gold">Construction</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 font-heading text-lg font-semibold text-white/70">
            The right people. The right skills. The right support.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
